import React from 'react'
import {useStateValue} from "../../context/StateProvider";
import {MdOutlineRestaurantMenu} from "react-icons/md";


const Cookies = () => {
    const [{},dispatch] = useStateValue()
    const hideCookies = () => {
        dispatch({
            type: "SET_COOKIE_ACCEPT",
            cookieAccept: true,
        });
        localStorage.setItem("CookiesAccept", JSON.stringify(true));
    };

    return (
        <div className="mx-5">
            <div
                className="fixed inset-x-0 bottom-0 z-10 flex justify-center gap-x-8 gap-y-4 bg-cardOverlay p-6 ring-1 ring-gray-900/10 md:flex-row md:items-center lg:px-8">
                <p className="text-sm leading-6 text-gray-500">
                    Мы используем Cookie. Если вы продолжаете использовать наш сайт, то соглашаетесь с нашей <a
                    className="font-semibold text-buttonColor" href="/privacy_policy">политикой
                    конфиденциальности</a>.
                </p>
                <div className="flex items-center justify-center cursor-pointer">
                    <div
                        className="relative flex items-center justify-center text-textColor"
                        onClick={() => hideCookies()}>
                        <MdOutlineRestaurantMenu className="text-headingColor text-4xl"/>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Cookies
